export class TranscodeService {
    static decodeString = (value: string) => {
        return decodeURIComponent(value);
    };

    static encodeString = (value: string) => {
        return encodeURIComponent(value);
    };
}

export default new TranscodeService();
